import { Shell, StepFooter } from "@/components/Shell";
import { OptionList } from "@/components/OptionList";
import { PRIORITY_ALERTS } from "@/lib/questions";

const YES_NO = [
  { id: "yes", label: "Sí" },
  { id: "no", label: "No" },
];

export function PriorityAlertsStep({ answers, setAnswer, onBack, onNext, progress }) {
  const canContinue = PRIORITY_ALERTS.every((q) => answers[q.id]);

  return (
    <Shell progress={progress}>
      <span className="cc-eyebrow">Alertas prioritarias</span>
      <h1 className="font-serif text-3xl sm:text-4xl mt-3">
        Situaciones que conviene revisar pronto
      </h1>
      <p className="mt-3 text-[hsl(var(--muted-foreground))]">
        Responder “Sí” no significa que algo esté mal. Sólo indica que es
        recomendable una valoración médica pronta.
      </p>

      <div className="mt-6 space-y-4">
        {PRIORITY_ALERTS.map((q) => (
          <div key={q.id} className="cc-card p-5">
            <p className="font-medium mb-3">{q.text}</p>
            <OptionList
              name={q.text}
              options={YES_NO}
              value={answers[q.id]}
              onChange={(v) => setAnswer(q.id, v)}
              testIdPrefix={q.id}
            />
          </div>
        ))}
      </div>

      <StepFooter>
        <button onClick={onBack} className="cc-btn-outline" data-testid="priority-back-btn">
          Atrás
        </button>
        <button
          onClick={onNext}
          disabled={!canContinue}
          className="cc-btn-primary"
          data-testid="priority-next-btn"
        >
          Continuar
        </button>
      </StepFooter>
    </Shell>
  );
}
